var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"listingSidebar sidebar algoliaSidebar"},[_c('div',{staticClass:"sidebarInner"},[_c('ais-clear-refinements',[_c('span',{attrs:{"slot":"resetLabel"},slot:"resetLabel"},[_vm._v("Clear Filters")])]),_c('ais-hierarchical-menu',{attrs:{"attributes":[
			'categories.lvl0',
			'categories.lvl1',
			'categories.lvl2'
			],"class-names":{
				'ais-HierarchicalMenu': 'sidebarInner',
				'ais-HierarchicalMenu-item': 'sidebarItem',
				'ais-HierarchicalMenu-link' : 'triangle',
				// 'ais-HierarchicalMenu-link' : 'ais-HierarchicalMenu-link triangle'

			}}}),_c('div',{staticClass:"brands-container padding-top greenBox"},[_vm._v("\n\t\t\tCan’t see what you want. Go to the brand supplier’s website through "),_c('router-link',{staticClass:"inline",attrs:{"to":{name:'brands'}}},[_vm._v("brands listing")]),_vm._v(", find what you want, click ‘"),_c('router-link',{staticClass:"inline",attrs:{"to":{name: 'brands'}}},[_vm._v("Get a Price")]),_vm._v("’ and get our everyday heavily discounted price.\n\t\t")],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }